import {Anrede, VerwandtschaftsArt} from "./enums";
import {Datum} from "./types";

/**
 * Daten einer Person.
 *
 * Nicht immer wird man alle Daten nutzen oder abfragen.
 * Z.B. könnte es für das Grabrecht uninteressant sein, welchen
 * Geburtsnamen oder Geburtstag die entsprechende Person hat.
 *
 * @author Andreas Wenger <andi@xenoage.com>
 */
export class Person {

  //Name
  anrede: Anrede;
	nachname: string;
  vorname: string;

  //Kontaktdaten
  plz: string;
  ort: string;
  strasse: string;
  telefon1: string;
  telefon2: string;
  email: string;
  fax: string;

  //Geburtsdaten
  geburtsdatum: Datum;
  geburtsname: string;
  geburtseintrag: string;
  geburtsort: string;

  //Verwandtschaftsverhältnis zum Verstorbenen
  verwandtschaft: VerwandtschaftsArt;

  //Ehe-Daten
  ehedatum: Datum;
  eheregisternr: string;
  eheort: string;
  ehestandesamt: string;
  eheendedatum: Datum;
  eheendeaktenzeichen: string;

  //sterbedatum
  sterbedatum: Datum;
  sterbebuchnr: string;

  //Weitere Angaben
  beruf: string;
  zahltfriedhof: boolean;
  verstorben: boolean;
  bemerkung: string;


  constructor(verwandtschaft?: VerwandtschaftsArt, anrede?: Anrede) {
    if (verwandtschaft != undefined) {
      this.verwandtschaft = verwandtschaft;
    }
    if (anrede != undefined) {
      this.anrede = anrede;
    }
  }

  /**
   * True, gdw. die Personendaten gesetzt sind.
   * Dafür muss zumindest der Nach- und Vorname gesetzt sein.
   */
  isSet() : boolean {
    return (this.nachname && this.vorname ? true : false);
  }

}



// WEBPACK FOOTER //
// ./src/model/person.ts